























































import Vue from "vue";
import Component from "vue-class-component";
import { features, maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";
import { IFixedPlatforms, IMobilePlatforms } from "@/store/features/models";
import { IHeaders } from "./interfaces";

@Component
export default class PlatformsTable extends Vue {
  search: string = "";
  headers: IHeaders[] = [
    {
      text: "Nombre",
      align: "start",
      value: "properties.nombre",
    },
  ];

  //Computed
  get mobilePlatforms() {
    return features.getters.mobilePlatforms;
  }

  get fixedPlatforms() {
    return features.getters.fixedPlatforms;
  }

  handleFixedClick(value: IFixedPlatforms) {
    maps.commit(MutationTypes.SET_MAPCENTER, value.geometry.coordinates);
    features.commit(MutationTypes.SET_SELECTED_FIXED_PLATFORM, value);
  }

  handleMobileClick(value: IMobilePlatforms) {
    maps.commit(MutationTypes.SET_MAPCENTER, value.geometry.coordinates);
    features.commit(MutationTypes.SET_SELECTED_MOBILE_PLATFORM, value);
  }
}
